import Link from '@components/common/Link/Link'
import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import Media from '@components/ui/Media/Media'

import { HeaderDropdownContentElementFragment } from '@lib/umbraco/generated/types.generated'
import clsx from 'clsx'
import { FC } from 'react'
import s from '../Navbar.module.scss'
export interface NavItemContentElementProps
  extends HeaderDropdownContentElementFragment {}
const NavItemContentElement: FC<NavItemContentElementProps> = ({
  image,
  body,
  header,
  link,
}) => {
  return (
    <Link link={link} className={clsx(s.submenuContentElement, s.flyoutItem)}>
      <span className={s.submenuContentElementImageWrapper}>
        <Media
          mediaWithCrops={image}
          className={s.submenuContentElementContainer}
          sizes="(max-width: 834px) 50vw, 20vw"
          mediaClassName={s.submenuContentElementImage}
          disableShopTheLook
        />
      </span>
      <span className={s.submenuContentElementContent}>
        <h2 className={s.header}>
          <span className={clsx(s.headerLinkText, s.underlineAnimation)}>
            {header}
          </span>
        </h2>
        <TrustedHtml html={body} className={s.body} />
      </span>
    </Link>
  )
}

export default NavItemContentElement
